import { useNavigate, useParams } from "react-router-dom";

// ** Custom Hooks
import { useSkin } from "@hooks/useSkin";
import { Controller, useForm } from "react-hook-form";

// ** Custom Components
import InputPasswordToggle from "@components/input-password-toggle";

// ** Reactstrap Imports
import {
  Button,
  Form,
  FormFeedback,
  Spinner,
} from "reactstrap";

// ** Styles
import "@styles/react/pages/page-authentication.scss";
import { useResetPassword } from "../api/resetPassword";
import { toast } from "react-toastify";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { ReactComponent as Logo } from "@src/assets/images/logo/logo.svg";

const passwordSchema = z
  .string()
  .min(8, "Use 8 characters")
  .regex(/[a-zA-Z]/, "Use at least 1 letter")
  .regex(/\d/, "Use at least 1 number")
  .regex(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, "Use at least 1 symbol");

const formSchema = z
  .object({
    password: passwordSchema,
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"], // path of error
  });

export const SetNewPassword = () => {
  const params = useParams();
  const navigate = useNavigate();

  const postResetPasswordMutation = useResetPassword({
    config: {
      onSuccess: () => {
        toast.success("Your password reseted successfully");
        navigate("/signin");
      },
    },
  });
  // ** Hooks

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(formSchema) });


  const onSubmit = (data) => {
    postResetPasswordMutation.mutateAsync({
      data: {
        new_password: data.password,
        confirm_password: data.confirmPassword,
        token: params.token,
      },
    });
  };

  return (
      <div className={" auth-wrapper auth-basic"}>
        <div className="auth-inner my-2">
          <div className={'d-flex justify-content-center align-items-center gap-50 pb-2'}>
            <Logo />
            <h1 className={'text-center fw-bolder mb-0'}>
              PmChess
            </h1>
          </div>
          <h5 className={'mb-1 rounded-3 text-center w-100 border py-1'}>
            Reset Your Password
          </h5>
      <Form
          className={"rounded-3 border p-2"}
          onSubmit={handleSubmit(onSubmit)}
      >
        <div className="">
          <Controller
              id="password"
              name="password"
              control={control}
              render={({ field }) => (
                  <InputPasswordToggle
                      label="New Password"
                      id="password"
                      className="input-group-merge form-floating"
                      placeholder=" "
                      size="lg"
                      {...field}
                  />
              )}
          />
          {errors.password && (
              <FormFeedback className="d-block mt-0 mb-1">
                {errors.password.message}
              </FormFeedback>
          )}
        </div>
        <div className="mt-2">
          <Controller
              id="confirmPassword"
              name="confirmPassword"
              control={control}
              render={({ field }) => (
                  <InputPasswordToggle
                      label="Confirm New Password"
                      id="confirmPassword"
                      className="input-group-merge form-floating"
                      placeholder=" "
                      size="lg"
                      {...field}
                  />
              )}
          />
          {errors.confirmPassword && (
              <FormFeedback className="d-block mt-0 mb-1">
                {errors.confirmPassword.message}
              </FormFeedback>
          )}
        </div>

        <Button type="submit" color="primary" block size="lg" className={'mt-2'} >
          {postResetPasswordMutation.isLoading ||
          postResetPasswordMutation.isPending ? (
              <Spinner size={"sm"} />
          ) : (
              "Reset Password"
          )}{" "}
        </Button>
      </Form>

        </div>
      </div>
          );
};
